<template>
  <vx-card title="Top-Kunden">
    <vs-table :data="customers" noDataText="Keine Daten vorhanden">
      <template slot="thead">
        <vs-th>Name</vs-th>
        <vs-th>Telefon</vs-th>
        <vs-th>Bestellungen</vs-th>
        <vs-th>Gesamtausgaben</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>{{ tr.name || "—" }}</vs-td>
          <vs-td>{{ tr.phone || "—" }}</vs-td>
          <vs-td>{{ tr.orderCount }}</vs-td>
          <vs-td>{{ tr.totalSpent.toFixed(2) }} €</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  name: "AnalyticsTopCustomers",
  computed: {
    customers() {
      const stats = this.$store.state.analytics.customerStats;
      return stats ? stats.topCustomers : [];
    },
  },
};
</script>
